import cn from 'bem-cn';

import { Stack } from '../Stack';
import { Icon } from '../Icon';

import { ViewsCounterProps } from './ViewsCounter.types';
import './ViewsCounter.scss';

const b = cn('views');
const defaultDirection = 'row';

export const ViewsCounter = (props: ViewsCounterProps) => {
    const { views, direction = defaultDirection } = props;

    return (
        <Stack title="Просмотры" direction={direction} alignItems="center" justifyContent="center" className={b()}>
            <span className={b('counter')}>{views}</span>
            <Icon className={b('icon')} name="eye" />
        </Stack>
    );
};
